import CityPropertyApi from "../../services/api/CityProperty";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath } from "../../utils";

function handleError(err) {
  console.log("error in city-property actions:", err);
}

export const setActiveCityProperty = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CITY_PROPERTY,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_CITY_PROPERTY,
    payload,
  };
};

export const getCityProperty = (id) => async (dispatch) => {
  try {
    let finalPayload = {
      city_id: id,
    };
    dispatch(setLoader(true));
    let response = await CityPropertyApi.getCityProperty(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const CityPropertyObj = getPath(response, "city_property", {});
      dispatch(setActiveCityProperty(CityPropertyObj));
      return CityPropertyObj;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateCityProperty = (id, data) => async (dispatch) => {
  try {
    const finalPayload = {
      city_property: data,
    };
    dispatch(setLoader(true));
    let response = await CityPropertyApi.updateCityProperty(id, finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const CityPropertyObj = getPath(response, "city_property", {});
      dispatch(resetState({ state: "activeCityProperty" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return CityPropertyObj;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
